import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Playlist} from '../../api/types';

export interface FavoritesState {
    playlists: Record<string, Playlist>;
}

const initialState: FavoritesState = {
    playlists: {},
};

export const favoritesSlice = createSlice({
    name: 'favorites',
    initialState,
    reducers: {
        toggleFavorite(state, action: PayloadAction<Playlist>) {
            const playlist = action.payload;
            if (state.playlists[playlist.id]) {
                delete state.playlists[playlist.id];
            } else {
                state.playlists[playlist.id] = playlist;
            }
        },
        // Used by FirestoreUserDataSync to apply remote state. Excluded from
        // userDataSyncMiddleware to avoid echo loops.
        setAllFavorites(state, action: PayloadAction<Record<string, Playlist>>) {
            state.playlists = action.payload;
        },
    },
});

export const {toggleFavorite, setAllFavorites} = favoritesSlice.actions;
export default favoritesSlice.reducer;
